/*=========================================================================================
  File Name: moduleStaffGetters.js
  Description: Staff Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Speed HRM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  
};
